import { PASSWORD_MINIMUM_LENGTH } from './constants';

// regular expressions from https://github.com/jquense/yup/blob/master/src/string.ts
const rEmail =
  /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

// slighlty modified from source: ((https?|ftp):)?\/\/ -> ((https?|ftp):\/\/)?
const rUrl =
  /^((https?|ftp):\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

export const is = {
  empty: (value) => value.trim().length === 0,
  email: (value) => rEmail.test(value),
  url: (value) => rUrl.test(value),
};

export function getAddressComponentNames(components, types) {
  const names = {};
  for (let i = 0; i < types.length; i++) {
    let type;
    let shortName;
    if (Array.isArray(types[i])) {
      type = types[i][0];
      shortName = types[i][1];
    } else {
      type = types[i];
      shortName = false;
    }
    const component = components.find(({ types }) => types.includes(type));
    names[type] = component
      ? component[shortName ? 'short_name' : 'long_name']
      : '';
  }
  return names;
}

export function validatePassword(password) {
  const hasMinimumLength = password.length >= PASSWORD_MINIMUM_LENGTH;
  const containsUppercaseLetter = /[A-Z]/.test(password);
  const containsLowercaseLetter = /[a-z]/.test(password);
  const containsDigit = /[0-9]/.test(password);
  const containsSpecialCharacter =
    /\!|\"|\#|\$|\%|\&|\'|\(|\)|\*|\+|\,|\-|\.|\/|\:|\;|\<|\=|\>|\?|\@|\[|\\|\]|\^|\_|\`|\{|\||\}|\~/.test(
      password
    );
  return {
    isValid:
      hasMinimumLength &&
      containsUppercaseLetter &&
      containsLowercaseLetter &&
      containsDigit &&
      containsSpecialCharacter,
    hasMinimumLength,
    containsUppercaseLetter,
    containsLowercaseLetter,
    containsDigit,
    containsSpecialCharacter,
  };
}

// GOOGLE PLACES OPENING_TIMES FORMATTING HELPERS
const _mapGoogleDaysToResmio = (day) => (day === 0 ? 6 : day - 1);

const _formatTime = (obj) => {
  if (!obj) return;

  if (typeof obj.hours === 'number') {
    const hh = String(obj.hours).padStart(2, '0');
    const mm = String(obj.minutes).padStart(2, '0');

    return `${hh}:${mm}`;
  }

  if (obj.time) {
    const t = obj.time.padStart(4, '0');

    return `${t.slice(0, 2)}:${t.slice(2)}`;
  }
};
// https://developers.google.com/maps/documentation/javascript/reference/places-service#PlaceOpeningHoursPeriod
// => "Clients can rely on always-open being represented as an open period
//     containing day with value 0 and time with value "0000", and no close"
const _is24_7 = (period) => {
  if (!period.close && period.open.day === 0 && period.open.time === '0000') {
    return true;
  }

  return false;
};

// Format:
// https://developers.google.com/maps/documentation/places/web-service/reference/rest/v1/places#openinghours
export const mapGoogleHoursToCustomFormat = (periods) => {
  if (!periods) return [];

  const results = [];

  for (const period of periods) {
    if (!period.open) continue;

    const openDay = _mapGoogleDaysToResmio(period.open.day);
    const begins = _formatTime(period.open);
    const ends = _formatTime(period.close);

    if (_is24_7(period)) {
      results.push({
        weekdays: [0, 1, 2, 3, 4, 5, 6],
        begins: '00:00',
        ends: '23:55',
      });
      continue;
    } else {
      results.push({
        weekdays: [openDay],
        begins,
        ends,
      });
    }
  }

  // merge periods with same begins/ends across multiple weekdays
  const grouped = {};
  for (const p of results) {
    const key = `${p.begins}-${p.ends}`;
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(...p.weekdays);
  }

  return Object.entries(grouped).map(([key, weekdays]) => {
    const [begins, ends] = key.split('-');

    // remove duplicates and sort weekdays
    const uniqueDays = Array.from(new Set(weekdays)).sort((a, b) => a - b);
    return { begins, ends, weekdays: uniqueDays };
  });
};
